import { auth, functions } from "../firebase";

// AdminUser records are server-owned (RTDB denies client writes) so a caller
// cannot attach themselves to a community they do not own. These callables
// are the only way to create an admin record or complete onboarding.
//
// The callable SDK attaches the caller's ID token automatically, but right
// after signup (or after a long-running onboarding wizard) that cached token
// can be stale or briefly unavailable, which reaches the function as
// context.auth == null and surfaces as "unauthenticated". Priming a fresh
// token first makes the attached token deterministic.
const primeToken = async (): Promise<void> => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error(
      "You are not signed in. Please sign in again and retry."
    );
  }
  await user.getIdToken(/* forceRefresh */ true);
};

export const bootstrapAdminUser = async (params: {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  phoneNumber: string;
}): Promise<{ communityId: string; alreadyProvisioned: boolean }> => {
  await primeToken();
  const callable = functions.httpsCallable("bootstrapAdminUser");
  const result = await callable(params);
  return (result.data || {}) as {
    communityId: string;
    alreadyProvisioned: boolean;
  };
};

export const completeAdminOnboarding = async (): Promise<void> => {
  await primeToken();
  const callable = functions.httpsCallable("completeAdminOnboarding");
  await callable({});
};
